
export default {
  setLayout: (state, payload ) => {
    state.layout = payload
  },
  
  setDashboardTitle: (state, title ) => {
    state.dashboardTitle = title
  },

  SET_ACTION_TYPE: (state, data) => {
    state.actionType = data;
  },

  SET_MENU_DATA: (state, data) => {
    state.menuData = data;
  }

}


// WEBPACK FOOTER //
// ./src/store/mutations.js